// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Utils = require("../../utils/Utils.bs.js");
var ViewStack = require("../../reason/common/ViewStack.bs.js");
var Icon__Jsx3 = require("../../uikit/reason/atoms/Icon/Icon__Jsx3.bs.js");
var View__Jsx3 = require("../../uikit/reason/helpers/View__Jsx3.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Next__Image = require("../../reason/next/Next__Image.bs.js");
var NukaCarousel = require("nuka-carousel").default;
var TailwindMerge = require("tailwind-merge");
var TailwindVariants = require("../../v5/bindings/TailwindVariants.bs.js");
var UIKit__BaseDialog = require("../../uikit/reason/molecules/Dialog/UIKit__BaseDialog.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var Theme__Color__Vars = require("../../reason/common/Theme/Theme__Color__Vars.bs.js");
var ReactAriaComponents = require("react-aria-components");
var VisuallyHidden = require("@reach/visually-hidden").default;
var UseWindowSize = require("uikit/hooks/useWindowSize");

var defaultControlsConfig = {};

var Nuka = {
  defaultControlsConfig: defaultControlsConfig
};

function fromAttachment(param) {
  var key = param.key;
  return {
          fullscreen: Utils.makeAttachmentUrl(1200, undefined, undefined, undefined, 1, undefined, key),
          large: Utils.makeAttachmentUrl(1200, 800, undefined, true, undefined, undefined, key),
          small: Utils.makeAttachmentUrl(750, 500, undefined, true, undefined, undefined, key),
          thumb: Utils.makeAttachmentUrl(90, 90, true, undefined, undefined, undefined, key)
        };
}

var CarouselImg_width = {
  large: 1200,
  small: 750
};

var CarouselImg_height = {
  large: 800,
  small: 500
};

var CarouselImg = {
  width: CarouselImg_width,
  height: CarouselImg_height,
  fromAttachment: fromAttachment
};

function TMPUIKIT____ImgGallery$ResponsiveImage(props) {
  var imgSize = props.imgSize;
  var alt = props.alt;
  var image = props.image;
  var match = imgSize === "fullscreen" ? [
      image.fullscreen,
      1200,
      undefined
    ] : (
      imgSize === "small" ? [
          image.small,
          750,
          500
        ] : [
          image.large,
          1200,
          800
        ]
    );
  var src = match[0];
  if (imgSize === "fullscreen") {
    return JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx(Next__Image.make, {
                      src: src,
                      fill: true,
                      unoptimized: true,
                      alt: alt,
                      className: "object-contain"
                    }),
                className: "w-full h-full relative"
              });
  } else {
    return JsxRuntime.jsx(Next__Image.make, {
                src: src,
                width: match[1],
                height: match[2],
                unoptimized: true,
                alt: alt,
                className: "object-contain w-full h-auto"
              });
  }
}

var ResponsiveImage = {
  make: TMPUIKIT____ImgGallery$ResponsiveImage
};

function TMPUIKIT____ImgGallery$TransparentButton(props) {
  var __className = props.className;
  var className = __className !== undefined ? __className : "";
  return JsxRuntime.jsx(ReactAriaComponents.Button, {
              children: props.children,
              className: (function (v) {
                  return TailwindMerge.twMerge([
                              "appearance-none border-0 bg-transparent p-0 m-0 rounded",
                              TailwindVariants.Utils.focusRing({
                                    isFocusVisible: v.isFocusVisible
                                  }),
                              className
                            ]);
                }),
              onClick: props.onClick
            });
}

var TransparentButton = {
  make: TMPUIKIT____ImgGallery$TransparentButton
};

var selectedShadowClass = "shadow-[0_0_3px_1px_#28618d]";

var unselectedShadowClass = "shadow-[0_0_3px_1px_transparent]";

function thumbnailStyles(highlightSelected, isSelected) {
  var shadow = isSelected && highlightSelected ? selectedShadowClass : unselectedShadowClass;
  return TailwindMerge.twMerge([
              "transform transition-all ease-linear duration-100 cursor-pointer flex items-center justify-center text-base font-bold bg-black/10 hover:scale-110",
              shadow
            ]);
}

function TMPUIKIT____ImgGallery$ImageThumbnails(props) {
  var __onSelectExtra = props.onSelectExtra;
  var onSelect = props.onSelect;
  var __imageSize = props.imageSize;
  var __maxLength = props.maxLength;
  var selectedIndex = props.selectedIndex;
  var images = props.images;
  var __highlightSelected = props.highlightSelected;
  var highlightSelected = __highlightSelected !== undefined ? __highlightSelected : true;
  var maxLength = __maxLength !== undefined ? __maxLength : 12;
  var imageSize = __imageSize !== undefined ? __imageSize : 75;
  var onSelectExtra = __onSelectExtra !== undefined ? __onSelectExtra : (function (prim) {
        
      });
  var makeThumbnail = function (img, i) {
    return JsxRuntime.jsx(TMPUIKIT____ImgGallery$TransparentButton, {
                onClick: (function (param) {
                    onSelect(i);
                  }),
                children: JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx("img", {
                            className: "object-cover",
                            height: imageSize.toString(),
                            src: img.thumb,
                            width: imageSize.toString()
                          }),
                      className: thumbnailStyles(highlightSelected, selectedIndex === i),
                      style: {
                        height: imageSize.toString() + "px",
                        width: imageSize.toString() + "px"
                      }
                    })
              }, img.thumb);
  };
  return JsxRuntime.jsx("div", {
              children: images.length > (maxLength + 1 | 0) ? images.filter(function (param, i) {
                          return i < maxLength;
                        }).map(makeThumbnail).concat([JsxRuntime.jsx(TMPUIKIT____ImgGallery$TransparentButton, {
                            onClick: (function (param) {
                                onSelect(maxLength);
                                onSelectExtra();
                              }),
                            children: JsxRuntime.jsx("div", {
                                  children: JsxRuntime.jsx("div", {
                                        children: "+" + (images.length - maxLength | 0).toString()
                                      }),
                                  className: thumbnailStyles(highlightSelected, selectedIndex >= maxLength),
                                  style: {
                                    height: imageSize.toString() + "px",
                                    width: imageSize.toString() + "px"
                                  }
                                })
                          }, "extra")]) : images.map(makeThumbnail),
              className: "grid justify-center w-full mb-4 gap-4 px-4",
              style: {
                gridTemplateColumns: "repeat(auto-fit, " + imageSize.toString() + "px)"
              }
            });
}

var ImageThumbnails = {
  View: undefined,
  selectedShadowClass: selectedShadowClass,
  unselectedShadowClass: unselectedShadowClass,
  thumbnailStyles: thumbnailStyles,
  make: TMPUIKIT____ImgGallery$ImageThumbnails
};

var onImageClass = "absolute top-2.5 left-1/2 -translate-x-1/2 p-[5px] bg-black/40 text-white";

var aboveImageClass = "absolute top-[-40px] left-1/2 -translate-x-1/2 p-[5px] text-white";

function TMPUIKIT____ImgGallery$SlideNumber(props) {
  return JsxRuntime.jsx("div", {
              children: (props.index + 1 | 0).toString() + (" of " + (props.length.toString() + " photos")),
              className: props.position === "onImage" ? onImageClass : aboveImageClass
            });
}

var SlideNumber = {
  onImageClass: onImageClass,
  aboveImageClass: aboveImageClass,
  make: TMPUIKIT____ImgGallery$SlideNumber
};

var openModalButtonContainerClass = "absolute top-2.5 right-2.5 p-[5px] bg-black/40 cursor-pointer rounded z-[1] text-white hover:bg-black/50";

var nextButton = JsxRuntime.jsxs(JsxRuntime.Fragment, {
      children: [
        JsxRuntime.jsx(VisuallyHidden, {
              children: "Next"
            }),
        JsxRuntime.jsx(Icon__Jsx3.make, {
              icon: "ArrowRight"
            })
      ]
    });

var prevButton = JsxRuntime.jsxs(JsxRuntime.Fragment, {
      children: [
        JsxRuntime.jsx(VisuallyHidden, {
              children: "Previous"
            }),
        JsxRuntime.jsx(Icon__Jsx3.make, {
              icon: "ArrowLeft"
            })
      ]
    });

var defaultControlsConfig_containerClassName = defaultControlsConfig.containerClassName;

var defaultControlsConfig_nextButtonStyle = defaultControlsConfig.nextButtonStyle;

var defaultControlsConfig_prevButtonStyle = defaultControlsConfig.prevButtonStyle;

var defaultControlsConfig_pagingDotsContainerClassName = defaultControlsConfig.pagingDotsContainerClassName;

var defaultControlsConfig_pagingDotsStyle = defaultControlsConfig.pagingDotsStyle;

var defaultControlsConfig$1 = {
  containerClassName: defaultControlsConfig_containerClassName,
  nextButtonClassName: "flex items-center text-white",
  nextButtonStyle: defaultControlsConfig_nextButtonStyle,
  nextButtonText: nextButton,
  prevButtonClassName: "flex items-center text-white",
  prevButtonStyle: defaultControlsConfig_prevButtonStyle,
  prevButtonText: prevButton,
  pagingDotsContainerClassName: defaultControlsConfig_pagingDotsContainerClassName,
  pagingDotsClassName: "px-[6px] py-[1px]",
  pagingDotsStyle: defaultControlsConfig_pagingDotsStyle
};

function TMPUIKIT____ImgGallery$Carousel(props) {
  var imgSize = props.imgSize;
  var __maxThumbnails = props.maxThumbnails;
  var selectedIndex = props.selectedIndex;
  var onSelect = props.onSelect;
  var openModal = props.openModal;
  var images = props.images;
  var maxThumbnails = __maxThumbnails !== undefined ? __maxThumbnails : 24;
  var windowSize = UseWindowSize.useWindowSize();
  var maxDots = imgSize === "small" ? Math.min(windowSize.width - 50 | 0, 668) / 20 | 0 : (windowSize.width - 30 | 0) / 20 | 0;
  return JsxRuntime.jsxs(ViewStack.make, {
              alignItems: "center",
              flexDirection: "column",
              position: "relative",
              className: "relative flex flex-col items-center",
              children: [
                openModal !== undefined ? JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsx(TMPUIKIT____ImgGallery$TransparentButton, {
                              onClick: (function (param) {
                                  openModal();
                                }),
                              children: JsxRuntime.jsx(Icon__Jsx3.make, {
                                    icon: "FullSizeView"
                                  })
                            }),
                        className: openModalButtonContainerClass
                      }) : null,
                JsxRuntime.jsx(NukaCarousel, {
                      beforeSlide: (function (_prev, nextIndex) {
                          onSelect(nextIndex);
                        }),
                      children: images.map(function (img, index) {
                            return JsxRuntime.jsx("div", {
                                        children: JsxRuntime.jsx(TMPUIKIT____ImgGallery$ResponsiveImage, {
                                              image: img,
                                              alt: index.toString(),
                                              imgSize: imgSize
                                            }),
                                        className: imgSize === "fullscreen" ? "inline-flex items-center w-full h-[calc(100vh-190px)]" : "inline-flex items-center"
                                      }, img.thumb);
                          }),
                      defaultControlsConfig: defaultControlsConfig$1,
                      enableKeyboardControls: true,
                      getControlsContainerStyles: (function (position) {
                          if (position !== "BottomCenter") {
                            return {
                                    width: "auto"
                                  };
                          }
                          var widthPx = Math.imul(maxDots, 20).toString() + "px";
                          return {
                                  bottom: "-4px",
                                  display: "flex",
                                  margin: "0 auto",
                                  minHeight: "24px",
                                  overflowX: "hidden",
                                  overflowY: "visible",
                                  width: widthPx,
                                  alignItems: "center",
                                  justifyContent: "center"
                                };
                        }),
                      slideIndex: selectedIndex
                    }, windowSize.width.toString()),
                JsxRuntime.jsx(TMPUIKIT____ImgGallery$SlideNumber, {
                      index: selectedIndex,
                      length: images.length,
                      position: imgSize === "fullscreen" ? "aboveImage" : "onImage"
                    }),
                JsxRuntime.jsx(TMPUIKIT____ImgGallery$ImageThumbnails, {
                      images: images,
                      selectedIndex: selectedIndex,
                      maxLength: maxThumbnails,
                      onSelect: onSelect,
                      onSelectExtra: openModal
                    })
              ]
            });
}

var Carousel = {
  openModalButtonContainerClass: openModalButtonContainerClass,
  nextButton: nextButton,
  prevButton: prevButton,
  defaultControlsConfig: defaultControlsConfig$1,
  make: TMPUIKIT____ImgGallery$Carousel
};

var className = "absolute top-2.5 left-1/2 -translate-x-1/2 p-[5px] bg-[rgba(34,34,34,0.66)] text-white text-sm font-medium rounded-[5px]";

function TMPUIKIT____ImgGallery$LightCarousel$LightSlideNumber(props) {
  return JsxRuntime.jsx("div", {
              children: (props.index + 1 | 0).toString() + (" / " + props.length.toString()),
              className: className
            });
}

var LightSlideNumber = {
  className: className,
  make: TMPUIKIT____ImgGallery$LightCarousel$LightSlideNumber
};

function TMPUIKIT____ImgGallery$LightCarousel(props) {
  var selectedIndex = props.selectedIndex;
  var onSelect = props.onSelect;
  var openModal = props.openModal;
  var images = props.images;
  var windowSize = UseWindowSize.useWindowSize();
  return JsxRuntime.jsxs(View__Jsx3.make, {
              alignItems: "center",
              flexDirection: "column",
              position: "relative",
              className: "relative flex flex-col items-center",
              children: [
                JsxRuntime.jsx(NukaCarousel, {
                      beforeSlide: (function (_prev, nextIndex) {
                          onSelect(nextIndex);
                        }),
                      children: images.map(function (img) {
                            return JsxRuntime.jsx(TMPUIKIT____ImgGallery$TransparentButton, {
                                        onClick: (function (param) {
                                            openModal();
                                          }),
                                        children: JsxRuntime.jsx("div", {
                                              children: JsxRuntime.jsx(TMPUIKIT____ImgGallery$ResponsiveImage, {
                                                    image: img,
                                                    alt: "",
                                                    imgSize: "small"
                                                  }),
                                              className: "inline-flex items-center w-full h-[calc(100vh-190px)]"
                                            })
                                      }, img.thumb);
                          }),
                      enableKeyboardControls: true,
                      slideIndex: selectedIndex,
                      withoutControls: true
                    }, windowSize.width.toString()),
                JsxRuntime.jsx(TMPUIKIT____ImgGallery$LightCarousel$LightSlideNumber, {
                      index: selectedIndex,
                      length: images.length
                    })
              ]
            });
}

var LightCarousel = {
  LightSlideNumber: LightSlideNumber,
  make: TMPUIKIT____ImgGallery$LightCarousel
};

function TMPUIKIT____ImgGallery$CarouselDialog(props) {
  var onDismiss = props.onDismiss;
  return JsxRuntime.jsxs(UIKit__BaseDialog.Animated.make, {
              ariaLabel: "Image Gallery",
              isOpen: props.isOpen,
              onDismiss: onDismiss,
              overlayClassName: "!bg-black/95 backdrop-blur-[3px] backdrop-brightness-[.8] backdrop-saturate-[.3] flex flex-col items-center",
              contentClassName: "!w-screen !max-w-[120vh] !m-0 !p-0 !bg-transparent",
              closeButton: Caml_option.some(JsxRuntime.jsxs(ReactAriaComponents.Button, {
                        children: [
                          JsxRuntime.jsx(VisuallyHidden, {
                                children: "Close"
                              }),
                          JsxRuntime.jsx(Icon__Jsx3.make, {
                                icon: "Cancel",
                                size: 24,
                                color: Theme__Color__Vars.white
                              })
                        ],
                        className: (function (param) {
                            return "p-[20px] cursor-pointer focus:outline-none self-end";
                          }),
                        onClick: (function (param) {
                            onDismiss();
                          })
                      })),
              transitionOnDestroyed: props.transitionOnDestroyed,
              children: [
                JsxRuntime.jsx(View__Jsx3.make, {
                      justifyContent: "flexEnd"
                    }),
                JsxRuntime.jsx("div", {
                      children: props.children,
                      className: "flex flex-col items-stretch w-full m-auto"
                    })
              ]
            });
}

var CarouselDialog = {
  make: TMPUIKIT____ImgGallery$CarouselDialog
};

exports.Nuka = Nuka;
exports.CarouselImg = CarouselImg;
exports.ResponsiveImage = ResponsiveImage;
exports.TransparentButton = TransparentButton;
exports.ImageThumbnails = ImageThumbnails;
exports.SlideNumber = SlideNumber;
exports.Carousel = Carousel;
exports.LightCarousel = LightCarousel;
exports.CarouselDialog = CarouselDialog;
/* nextButton Not a pure module */
